<template>
  <div id="app">
    <div id="front">
      <navbar-ezw id="nav"></navbar-ezw>
      <router-view id="view" />
      <footer-ezw id="footer"></footer-ezw>
    </div>
  </div>
</template>

<script>
import Navbar from './components/Navbar.vue'
import Footer from './components/Footer.vue'
export default {
  data() {
    return {
      route: "",
      start: true
    }
  },
  components: {
    'navbar-ezw': Navbar,
    'footer-ezw': Footer
  },
  watch: {
    '$route': 'changeRoute'
  },
  mounted() {
    this.changeRoute();
  },
  methods: {
    changeRoute() {
      this.route = this.$route.name
    }
  },
  computed: {
    visibleSlides: function () {
      return this.images.filter(function(image) {return image.visible == true;});
    }
  },
  metaInfo: {
      title: 'EZW Werkzeugbau'    
  }
}
</script>

<style>
.container {
  padding-left: 0px!important;
  padding-right: 0px!important;
}

#front {
  z-index: 1;
}

#nav {
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 3;
  box-shadow: 0 3px 5px grey;
}

#view {
  z-index: 2;
  width: 100%;
  padding-bottom: 175px;
}

#footer {
  position: absolute;
  bottom: 0%;
  width: 100%;
  height: 175px; 
}

#app {
  background-color: white;
  position: relative;
  width: 100%;
  min-height: 100vh;
}

.carousel-indicators {
    background-color: rgba(0,0,0,0.2)!important;
    border-radius: 20px!important;
    margin-bottom: -20px!important;
}

@media only screen and (max-width: 576px) { 
    .carousel-indicators {
      margin-bottom: -30px!important;
    }
}
</style>
